import { DEFAULT_PRIMARY_COLOR } from '../colorUtils'
import useTheme from './useTheme'

const usePrimaryColor = (): string => {
  const { primaryColor } = useTheme()
  return primaryColor ?? DEFAULT_PRIMARY_COLOR
}

export default usePrimaryColor
